import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Checkbox, Form, Input, Select, Tooltip, Icon
} from 'antd';
import settings from 'settings';
import { list } from 'actions';
import { FormWrapper } from 'components/Page';
import { canViewOptimiser, canAdminOptimiser } from 'library/optimiser';
import REDUCER_KEY from 'reducers/reducer.keys';

const FormItem = Form.Item;
const { Option } = Select;

const mapStateToProps = state => ({
  themes: state.api.themes.data.results
});

const mapDispatchToProps = dispatch => ({
  loadThemes() {
    const page = 0;
    const pageSize = settings.APP_CONFIG.dropListSize;
    const filterBy = [{
      id: 'model',
      value: null
    }];
    const sortBy = [{
      id: 'model',
      desc: false
    }];

    dispatch(list(REDUCER_KEY.themes.key, page, pageSize, filterBy, sortBy));
  }
});

const mapPropsToFields = (props) => {
  const { dataSource } = props;
  const {
    mutually_exclusive, used_by_optimiser, theme, name, theme_id
  } = dataSource;

  const themeId = theme ? theme.id : null;

  return {
    name: Form.createFormField({ value: name }),
    theme_id: Form.createFormField({ value: theme_id || themeId }),
    mutually_exclusive: Form.createFormField({ value: mutually_exclusive }),
    used_by_optimiser: Form.createFormField({ value: used_by_optimiser })
  };
};

const onFieldsChange = (props, fields) => {
  const { onFieldsChange: dispatchOnFieldsChange } = props;
  if (dispatchOnFieldsChange) {
    dispatchOnFieldsChange(fields);
  }
};

const onValuesChange = (props, values) => {
  const { onValuesChange: dispatchOnValuesChange } = props;
  if (dispatchOnValuesChange) {
    dispatchOnValuesChange(values);
  }
};

class FormInput extends Component {
  componentDidMount() {
    const { loadThemes } = this.props;
    loadThemes();
  }

  render() {
    const {
      canAdmin, checkboxFormItemLayout, dataSource, isEditMode, themes, inputFormItemLayout, form
    } = this.props;
    const { getFieldDecorator } = form;
    const {
      mutually_exclusive, used_by_optimiser, theme, name
    } = dataSource;
    const themeId = theme ? theme.id : null;
    const readonly = !canAdmin;
    return (
      <Form>
        <FormItem {...inputFormItemLayout} label="Name">
          {
            getFieldDecorator('name', {
              initialValue: name,
              rules: [{
                required: true,
                message: 'Please enter the Tag name.'
              }]
            })(<Input disabled={readonly} maxLength={100} />)
          }
        </FormItem>
        <FormItem {...inputFormItemLayout} label="Theme">
          {
            getFieldDecorator('theme_id', {
              initialValue: themeId,
              rules: [{
                required: true,
                message: 'Please select a Theme'
              }]
            })(
              <Select
                showSearch
                disabled={readonly || isEditMode}
                placeholder="Select a Theme"
                optionFilterProp="children"
                filterOption={(input, option) => option.props.children.toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0}
              >
                {themes.map(item => <Option key={item.id} value={item.id}>{item.model}</Option>)}
              </Select>
            )
          }
        </FormItem>
        <FormItem {...checkboxFormItemLayout}>
          {
            getFieldDecorator('mutually_exclusive', {
              initialValue: mutually_exclusive,
              valuePropName: 'checked'
            })(<Checkbox disabled={readonly || isEditMode}>Mutually Exclusive</Checkbox>)
          }
        </FormItem>
        {(() => {
          const optimiserEnabled = canViewOptimiser();
          if (!optimiserEnabled) return null;
          return (
            <FormItem {...checkboxFormItemLayout}>
              {
                getFieldDecorator('used_by_optimiser', {
                  initialValue: used_by_optimiser,
                  valuePropName: 'checked'
                })(
                  <Checkbox disabled={readonly || !canAdminOptimiser()}>
                    Used by Optimiser
                    {' '}
                    <Tooltip title="Whether this tag is used by the Optimiser or not">
                      <Icon type="question-circle-o" />
                    </Tooltip>
                  </Checkbox>
                )
              }
            </FormItem>
          );
        })()}
      </Form>
    );
  }
}

FormInput.propTypes = {
  canAdmin: PropTypes.bool,
  checkboxFormItemLayout: PropTypes.object,
  dataSource: PropTypes.object,
  form: PropTypes.object,
  inputFormItemLayout: PropTypes.object,
  isEditMode: PropTypes.bool,
  themes: PropTypes.array,
  onFieldsChange: PropTypes.func,
  onValuesChange: PropTypes.func,
  loadThemes: PropTypes.func
};

FormInput.defaultProps = {
  canAdmin: false,
  checkboxFormItemLayout: {},
  dataSource: {},
  form: {},
  inputFormItemLayout: {},
  isEditMode: false,
  themes: [],
  onFieldsChange() {
  },
  onValuesChange() {
  },
  loadThemes() {
  }
};

const ConnectedFormInput = connect(mapStateToProps, mapDispatchToProps)(FormInput);

const TagFormInput = FormWrapper(Form.create({
  mapPropsToFields,
  onFieldsChange,
  onValuesChange
})(ConnectedFormInput));

export default TagFormInput;
